import { ControlledNumberAutocomplete } from '@if/mui'
import type { JSX } from 'react'
import { Control, FieldPathByValue, FieldValues } from 'react-hook-form'
import { ERS_SCORE_OPTIONS } from '../hooks/ersScoreOptions'

interface ErsScoreAutocompleteProps<
  TFieldValues extends FieldValues,
  TName extends FieldPathByValue<TFieldValues, number | null>,
> {
  control: Control<TFieldValues>
  name: TName
  label?: string
}

const ErsScoreAutocomplete = <
  TFieldValues extends FieldValues,
  TName extends FieldPathByValue<TFieldValues, number | null>,
>({
  control,
  name,
  label,
}: ErsScoreAutocompleteProps<TFieldValues, TName>): JSX.Element => (
  <ControlledNumberAutocomplete
    control={control}
    name={name}
    label={label}
    options={ERS_SCORE_OPTIONS}
    disableDecimals
    freeSolo
    autoSelect
    selectOnFocus
    handleHomeEndKeys
    fullWidth
  />
)

export default ErsScoreAutocomplete
